
import { Component, Vue } from 'vue-property-decorator'
import InsuranceAgreements from '@/components/insurances/insurance-agreements.vue'
@Component({
  components: {
    InsuranceAgreements
  }
})
export default class InsuranceAgreementsView extends Vue {}
